module.exports = __webpack_public_path__ + "img/labeled-samples.2b8a9dcd.jpg";